import { useCallback } from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Button from '@zenbusiness/zui/Button';
import Stack from '@zenbusiness/zui/Stack';

import { CONTACT_US_URL } from '#client/constants';

export function SubscriptionCancelActions({ onConfirm, service }) {
  const handleContactCS = useCallback(() => {
    window.location.href = CONTACT_US_URL;
  }, []);

  return (
    <Stack
      gap={2}
      sx={{
        flexDirection: { xs: 'column', sm: 'row' },
        '& > *': { flex: 1 }
      }}
    >
      <Button
        variant="outlined"
        size="large"
        clickstreamProps={{ elementName: 'cancel_trial_contact_cs', ...(service && { dynamicProperties: { subscriptionService: service } }) }}
        onClick={handleContactCS}
      >
        <FormattedMessage id="dashboard.subscriptionCancel.actions.contactCS" />
      </Button>
      <Button
        variant="contained"
        size="large"
        clickstreamProps={{ elementName: 'cancel_trial_confirm', ...(service && { dynamicProperties: { subscriptionService: service } }) }}
        onClick={onConfirm}
      >
        <FormattedMessage id="dashboard.subscriptionCancel.reason.continue" />
      </Button>
    </Stack>
  );
}

SubscriptionCancelActions.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  service: PropTypes.string
};
